/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Backtosignin3Inputs */

const zh_auth_backtosignin3 = /** @type {(inputs: Auth_Backtosignin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回登录`)
};

const en_auth_backtosignin3 = /** @type {(inputs: Auth_Backtosignin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to sign in`)
};

const es_auth_backtosignin3 = /** @type {(inputs: Auth_Backtosignin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a iniciar sesión`)
};

/**
* | output |
* | --- |
* | "Back to sign in" |
*
* @param {Auth_Backtosignin3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_backtosignin3 = /** @type {((inputs?: Auth_Backtosignin3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Backtosignin3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_backtosignin3(inputs)
	if (locale === "en") return en_auth_backtosignin3(inputs)
	return es_auth_backtosignin3(inputs)
});
export { auth_backtosignin3 as "auth_backToSignIn" }